import Head from "next/head";
import Homepage from "../../src/Components/merchants/merchants";

export default function Home(props) {
  return (
    <div className="main-content">
      <Head>
        <title>Merchants</title>
        <link rel="icon" href="/favicon.svg" />
        <meta content="width=1024, initial-scale=1.0; " name="viewport" />
      </Head>
      <Homepage />
    </div>
  );
}
